import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/Landing";
import CaseFileZero from "./pages/CaseFileZero";
import Telemetry from "./pages/Telemetry";

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Landing />} />
                    <Route path="/case-file/zero" element={<CaseFileZero />} />
                    <Route path="/telemetry" element={<Telemetry />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
